import React from 'react'
import { useQuery } from '@apollo/react-hooks'
import NoReelsPlaceholder from 'components/AdvancedEditor/ReelBuilder/NoReelsPlaceholder'
import VI_PROJECT_REELS_QUERY, {
  VI_DYNAMIC_PROJECT_REELS_QUERY
} from './ProjectReels.query'
import ListContainer from './ListContainer'
import { getNextPagePath } from 'utils'

const ProjectReels = ({
  projectId,
  onReelSelect,
  excludeReelIds,
  selectedReelId
}) => {
  const {
    data: {
      reels: {
        graphql: reels = [],
        jsonapi: { links: { next } = {} } = {}
      } = {}
    } = {},
    loading,
    fetchMore
  } = useQuery(VI_PROJECT_REELS_QUERY, {
    variables: { projectId },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  })

  return loading || reels.length ? (
    <ListContainer
      reels={reels}
      loading={loading}
      next={next}
      fetchMore={() => {
        if (!next || loading) {
          return
        }

        fetchMore({
          query: VI_DYNAMIC_PROJECT_REELS_QUERY,
          variables: {
            path: getNextPagePath(next)
          },
          updateQuery: (prev, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prev

            return {
              ...prev,
              reels: {
                ...fetchMoreResult.reels,
                graphql: [
                  ...prev.reels.graphql,
                  ...fetchMoreResult.reels.graphql
                ]
              }
            }
          }
        })
      }}
      onReelSelect={onReelSelect}
      excludeReelIds={excludeReelIds}
      selectedReelId={selectedReelId}
    />
  ) : (
    <NoReelsPlaceholder />
  )
}

export default ProjectReels
